import { render, staticRenderFns } from "./TotalrecdetailbysellerReport.vue?vue&type=template&id=df5271b6"
import script from "./TotalrecdetailbysellerReport.vue?vue&type=script&lang=js"
export * from "./TotalrecdetailbysellerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports